import { apiRequest, API_BASE_URL } from './api';

export const locationApi = {
  getAllCountries: () => apiRequest('/location/countries'),
  getCitiesByCountryId: (id) => apiRequest(`/location/countries/${id}/cities`),

  getPendingCities: (page = 0, size = 50) =>
    apiRequest(`/admin/location/cities/pending?page=${page}&size=${size}`),

  approveCity: (id, { nameEn, nameHe, latitude, longitude } = {}) =>
    apiRequest(`/admin/location/cities/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ nameEn, nameHe, latitude, longitude }),
    }),

  mergeCity: (sourceId, targetId) =>
    apiRequest(`/admin/location/cities/${sourceId}/merge?into=${targetId}`, { method: 'POST' }),

  adminListCities: ({ countryId, q, verified, page = 0, size = 50 } = {}) => {
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('size', String(size));
    if (countryId != null) params.set('countryId', String(countryId));
    if (q && q.trim()) params.set('q', q.trim());
    if (verified === true || verified === false) params.set('verified', String(verified));
    return apiRequest(`/admin/location/cities?${params.toString()}`);
  },

  bulkMergeCities: (sourceIds, targetId) =>
    apiRequest('/admin/location/cities/merge-bulk', {
      method: 'POST',
      body: JSON.stringify({ sourceIds, targetId }),
    }),

  deleteCity: async (id) => {
    const token = localStorage.getItem('authToken');
    const headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = `Bearer ${token}`;

    const response = await fetch(`${API_BASE_URL}/admin/location/cities/${id}`, {
      method: 'DELETE',
      headers,
    });

    if (response.status === 401) {
      localStorage.removeItem('authToken');
      window.location.href = '/login';
      return null;
    }

    if (response.status === 409) {
      let body = {};
      try { body = await response.json(); } catch (_) { /* ignore parse failures */ }
      const refs = body.referencedBy
        ? ` Referenced by: ${body.referencedBy.join(', ')}.`
        : '';
      throw new Error(`Cannot delete city — it is still referenced by other records.${refs}`);
    }

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Delete failed: ${response.status} ${response.statusText}${text ? ` — ${text}` : ''}`);
    }

    const text = await response.text();
    return text ? JSON.parse(text) : {};
  },
};
